export const isEmpty = (value: any) => {
    return (value == null || value.length === 0);
}

export const returnString = (value: any) => {
    if(isEmpty(value))
        return ""
    return value
}